<h2 mat-dialog-title>
  @if (!isTrial) {
    {{ acChangeEditionDialogConfig.title.key | translate }}
  } @else {
    <span>{{ acUpgradeEditionDialogConfig.title.key | translate }}</span>
  }
</h2>
<mat-dialog-content>
  <div class="select-product-edition-text">
    {{ acChangeEditionDialogConfig.selectEdition.key | translate }}
  </div>

  <div class="app-info-edition-dropdown">
    <div class="app-name-container">
      @if (data.appIconUrl) {
        <va-icon
          [diameter]="32"
          [iconName]="data.appIconUrl"
          [iconUrl]="data.appIconUrl + '=s256'"
        ></va-icon>
      }
      {{ data.appName }}
    </div>

    <mat-select
      class="edition-dropdown"
      [(value)]="selectedPlanType"
      #select="matSelect"
      (selectionChange)="planTypeChanged()"
      >
      <mat-select-trigger>{{ selectedPlanType }}</mat-select-trigger>
      @for (planType of PlanTypeList; track planType) {
        <mat-option [value]="planType">
          <div class="edition-option">
            <div>
              {{ planType }}
            </div>
            @if (planType === currentPlanType && select.panelOpen) {
              <div class="badge">
                {{ acChangeEditionDialogConfig.current.key | translate }}
              </div>
            }
          </div>
        </mat-option>
      }
    </mat-select>
  </div>

  <div class="select-contacts-text">
    {{ acChangeEditionDialogConfig.selectContacts.key | translate }}
  </div>

  <mat-radio-group class="radio-group" [value]="selectedContactLimit" (change)="changeSelectedContactLimit($event)">
    @for (limit of ContactLimitList; track limit) {
      <mat-radio-button
        class="radio-button"
        color="primary"
        [value]="limit"
      [disabled]="
        (selectedPlanType !== PlanType.Plus &&
          selectedPlanType !== PlanType.Lite &&
          limit === ContactLimit.limit1000) ||
        (selectedPlanType !== PlanType.Lite && limit === ContactLimit.limit500)
      "
        >
        <span class="contact-limit">
          <span>{{ limit }}</span>
          @if (limit === currentContactLimit) {
            <span class="badge">
              {{ acChangeEditionDialogConfig.current.key | translate }}
            </span>
          }
        </span>
      </mat-radio-button>
    }
  </mat-radio-group>

  <div class="confirmation">
    <mat-checkbox class="checkbox" color="primary" [(ngModel)]="confirmationCheckbox"></mat-checkbox>
    @if (!isTrial) {
      <span>{{ acChangeEditionDialogConfig.confirmation.key | translate }}</span>
    } @else {
      <span>{{ acUpgradeEditionDialogConfig.confirmation.key | translate }}</span>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button matDialogClose color="primary">
    {{ acChangeEditionDialogConfig.cancelButton.key | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="activateEditionForApp()"
    [disabled]="
      (!isTrial && currentContactLimit === selectedContactLimit && currentPlanType === selectedPlanType) ||
      !selectedContactLimit ||
      !confirmationCheckbox ||
      submitting
    "
    >
    @if (!submitting) {
      @if (!isTrial) {
        {{ acChangeEditionDialogConfig.changeEditionButton.key | translate }}
      } @else {
        {{ acUpgradeEditionDialogConfig.upgradeEditionButton.key | translate }}
      }
    } @else {
      <mat-spinner [diameter]="24" [strokeWidth]="4"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
